import { Api } from '../../../../../utility/client';

export const updateDisabledStatus = async (
  roomId: string,
  event: 'enable' | 'disable',
) => Api.post('/v1/rooms/disable', { roomId, event });
